import {ThemeProvider} from "styled-components";
import {theme} from "../theme";
import {GlobalStyles} from "../theme/";
import {Outlet} from "react-router";

export const StyledProvider = ({children}:{children: any}) => {

    return <ThemeProvider theme={theme}>
        <GlobalStyles/>
        {children}
    </ThemeProvider>
}
